import { PropsWithChildren } from 'react';

import { BoxProps } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';

export function EnterpriseResourceContainer({ children, ...props }: PropsWithChildren<BoxProps>) {
  return (
    <ContentContainer padding={{ base: '0px 16px 0px 16px', md: '0px 124px 0px 124px' }} {...props}>
      {children}
    </ContentContainer>
  );
}
